// composable: useUserApi.ts
import { inject, InjectionKey } from 'vue';
import { DayApiService } from './dayApiService';

export const DAY_API_KEY: InjectionKey<DayApiService> = Symbol('DayApiService');

export function useDayApi(): DayApiService {
	const service = inject<DayApiService>(DAY_API_KEY);
	if (!service) throw new Error('DayApiService not provided');
	return service;
}
